import React from 'react';

function BenefitsCarousel() {
    return (
        <>
            <h6 className="text-muted mb-3 p-4 pb-0">Beneficios Exclusivos</h6>
            <div className="card mb-4 bg-transparent border-0 p-0">
                <div className="card-body p-0">
                    
                    <div className="benefits-scroll">
                        <div className="d-flex gap-3" style={{ overflowX: 'auto', paddingBottom: '1rem' }}>
                            {/* Card 1 - Genérica */}
                            <div className="benefit-card" style={{ minWidth: '200px' }}>
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body p-4 d-flex flex-column justify-content-center">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="icon-circle bg-primary-subtle">
                                                <i className="bi bi-gift text-primary icon-md"></i>
                                            </div>
                                        </div>
                                        <h6 className="mb-2">Ahorrá en lo que más necesitás</h6>
                                        <p className="text-muted small mb-0">
                                            Conocé todos los beneficios que tenemos para vos en nuestra red de comercios adheridos.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Card 2 - Fashion Mall */}
                            <div className="benefit-card" style={{ minWidth: '200px' }}>
                                <div className="card border-0 shadow-sm h-100">
                                    <div 
                                        className="card-header p-0 border-0"
                                        style={{
                                            height: '180px',
                                            backgroundImage: 'url(/img/retails/fashion.webp)',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            borderTopLeftRadius: 'var(--bs-card-border-radius)',
                                            borderTopRightRadius: 'var(--bs-card-border-radius)'
                                        }}
                                    />
                                    <div className="card-body p-4 pb-0">
                                        <h6 className="mb-2">Renová tu estilo</h6>
                                        <p className="text-muted small mb-0">
                                            20% de descuento en Fashion Mall y hasta 12 cuotas
                                        </p>
                                    </div>
                                    <div className="card-footer bg-transparent border-0 p-4 pt-0">
                                        <span className="badge bg-primary-subtle text-primary">
                                            <i className="bi bi-calendar-event me-1"></i>
                                            Sábados de Febrero
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Card 3 - Tech Store */}
                            <div className="benefit-card" style={{ minWidth: '200px' }}>
                                <div className="card border-0 shadow-sm h-100">
                                    <div 
                                        className="card-header p-0 border-0"
                                        style={{
                                            height: '180px',
                                            backgroundImage: 'url(/img/retails/tech.webp)',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            borderTopLeftRadius: 'var(--bs-card-border-radius)',
                                            borderTopRightRadius: 'var(--bs-card-border-radius)'
                                        }}
                                    />
                                    <div className="card-body p-4 pb-0">
                                        <h6 className="mb-2">Lo mejor en tecnología</h6>
                                        <p className="text-muted small mb-0">
                                            Te ofrecemos una tasa preferencial en Tech Store
                                        </p>
                                    </div>
                                    <div className="card-footer bg-transparent border-0 p-4 pt-0">
                                        <span className="badge bg-primary-subtle text-primary">
                                            <i className="bi bi-calendar-event me-1"></i>
                                            Martes y Jueves
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Card 4 - Deportes XYZ */}
                            <div className="benefit-card" style={{ minWidth: '200px' }}>
                                <div className="card border-0 shadow-sm h-100">
                                    <div 
                                        className="card-header p-0 border-0"
                                        style={{
                                            height: '180px',
                                            backgroundImage: 'url(/img/retails/deportes.webp)',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            borderTopLeftRadius: 'var(--bs-card-border-radius)',
                                            borderTopRightRadius: 'var(--bs-card-border-radius)'
                                        }}
                                    />
                                    <div className="card-body p-4 pb-0">
                                        <h6 className="mb-2">Equipate para el deporte</h6>
                                        <p className="text-muted small mb-0">
                                            15% de descuento en zapatillas y accesorios en Deportes XYZ
                                        </p>
                                    </div>
                                    <div className="card-footer bg-transparent border-0 p-4 pt-0">
                                        <span className="badge bg-primary-subtle text-primary">
                                            <i className="bi bi-calendar-event me-1"></i>
                                            Todos los días
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Card Ver Todos */}
                            <div className="benefit-card" style={{ minWidth: '200px' }}>
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body p-4 d-flex flex-column justify-content-center">
                                        <div className="text-center">
                                            <div className="icon-circle bg-primary-subtle mx-auto mb-3">
                                                <i className="bi bi-arrow-right text-primary icon-md"></i>
                                            </div>
                                            <h6 className="mb-2">Ver todos los beneficios</h6>
                                            <p className="text-muted small mb-0">
                                                Descubrí más descuentos y promociones
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BenefitsCarousel; 